import { shell, Eyebrow, Title, serif, Arrow, SubTitle } from "../components/CommonComponents";


const WhyChoose = ({ reasons, title, images }) => {
  return (
    <section id="why" className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
      <div className={shell}>
        <div className="grid gap-10 lg:grid-cols-[0.75fr_1.25fr]">
          <div>
            <Eyebrow>Why ISBM University</Eyebrow>
            <Title
              position="middle"
              after={`${title} at ISBM University`}
              highlight="Why Choose"
            />
            <SubTitle> An education designed around where you want to go.An education designed around where you want to go.</SubTitle>
          </div>
          <div className="grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">
            {reasons.map((reason, i) => (
              <article key={reason} className="min-h-[210px] bg-white p-7">
                <span className="text-sm font-bold text-[#8B1E3F]">
                  0{i + 1}
                </span>
                <p className="mt-7 text-base leading-8 text-[#526071]">
                  {reason}
                </p>
              </article>
            ))}
          </div>
        </div>
        <div className="relative mt-10 overflow-hidden rounded-[8px_34px_8px_8px] bg-[#8B1E3F] text-white">
          <img
            src={images.seminar}
            alt="Industry interaction at ISBM University"
            className="absolute inset-0 h-full w-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#8B1E3F] via-[#8B1E3F]/95 to-[#071A2F]/60" />
          <div className="relative flex min-h-[260px] flex-col justify-center gap-7 p-8 sm:p-10 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-3xl">
              <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                Experience the programme
              </span>
              <p className={`${serif} mt-4 text-3xl leading-tight sm:text-4xl`}>
                See how academic depth connects with professional exposure.
              </p>
            </div>
            <a
              href="/contact-us"
              className="inline-flex min-h-14 shrink-0 items-center gap-6 rounded-[3px_18px_3px_3px] bg-[#D5AD57] px-7 text-sm font-bold text-[#071A2F]"
            >
              Book a counselling session <Arrow />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
